module.exports = __webpack_public_path__ + "img/个人3.b834825c.png";